import { Component, Input, OnInit } from '@angular/core';

import { ISRMSelectedQuestionAndAnswer } from '../../../core/models/srm.model';
import { FiltersService } from '../../../core/services/filters/filters.service';
import { FracToDecService } from '../../../core/services/fracToDec/frac-to-dec.service';
import { UserService } from '../../../core/services/user/user.service';
import { ISRMBetPlacementModel } from '../../../quickbet/models/quickbet-receipt.model';
import { QuickbetService } from '../../../quickbet/services/quickbetService/quickbet.service';

@Component({
    selector: 'srm-quickbet-receipt',
    templateUrl: 'srm-quickbet-receipt.component.html',
    styleUrls: ['../../../quickbet/components/quickbetReceipt/quickbet-receipt.component.scss', 'srm-quickbet-receipt.component.scss'],
    standalone: false,
})
export class SrmQuickbetReceiptComponent implements OnInit {
    @Input() srmBetReceipt: ISRMBetPlacementModel;
    @Input() selectedQuestionAndAnswers: ISRMSelectedQuestionAndAnswer[];
    srmOdds: string;
    finalStake: string;
    payout: string;
    YOUR_BETS: string = 'Your Bets: (1)';

    constructor(
        protected user: UserService,
        protected filtersService: FiltersService,
        protected quickbetService: QuickbetService,
        protected fracToDecService: FracToDecService,
    ) {}

    ngOnInit(): void {
        this.getOdds();
        this.finalStake = this.getStake(this.srmBetReceipt.totalStake);
        this.payout = (
            +(this.srmBetReceipt?.betPotentialWin as string) && this.setCurrency(this.srmBetReceipt?.betPotentialWin as string)
        ).toString();
    }

    /**
     * Gets stake
     * @param {string} val
     * @returns {string}
     */
    getStake(val: string): string {
        if (!val) {
            return '';
        }

        return this.setCurrency(parseFloat(val).toString());
    }

    /**
     * sets currency to stake
     * @param {string} val
     * @returns {string}
     */
    setCurrency(val: string): string {
        return this.filtersService.setCurrency(val, this.user.currencySymbol);
    }

    /**
     * Get potential payout value
     * @param {string} payout
     * @returns {string}
     */
    getPotentialPayoutValue(payout: string): string {
        return payout || 'N/A';
    }

    /**
     * Get odds in correct format
     * @returns void
     */
    getOdds(): void {
        let priceNum = this.srmBetReceipt?.bet?.leg?.[0].part?.[0].priceNum;
        let priceDen = this.srmBetReceipt?.bet?.leg?.[0].part?.[0].priceDen;

        if (priceDen !== 1) {
            priceNum = +this.fracToDecService.getNumberWith2Decimals((priceNum ?? 0) / (priceDen ?? 0));
            priceDen = 1;
        }
        this.srmOdds = this.quickbetService.getOdds({ priceNum, priceDen });
    }
}
